import QuizLabelParameter from '@components/text/QuizLabelParameter'
import { Box, Flex, MantineStyleProps, Text } from '@mantine/core'
import { IQuizLabelParameter } from '@components/text/QuizLabelParameter'
import React from 'react'

interface IQuizParameterTemplateDeficit {
    children?: React.ReactNode
    label?: IQuizLabelParameter['label']
    description?: IQuizLabelParameter['description']
    required?: IQuizLabelParameter['required']
    afterLabel?: string
    bg?: MantineStyleProps['bg']
}

const QuizParameterTemplateDeficit = ({
    children,
    label = '',
    description,
    required,
    afterLabel = '',
    bg = 'none',
}: IQuizParameterTemplateDeficit) => {
    return (
        <Flex
            style={{ borderRadius: '16px' }}
            ml={{ xs: '0', lg: '0' }}
            py='lg'
            pl='lg'
            pr={{ xs: 'lg', md: 0 }}
            bg={bg}
            justify={{ xs: 'start', md: 'space-between' }}
            align={{ xs: 'start', sm: 'center' }}
            direction={{ xs: 'column', md: 'row' }}
        >
            <QuizLabelParameter
                c='text.0'
                fw='bold'
                {...{ label, description, required }}
            />
            <Flex gap='md' align='center' wrap='wrap'>
                <Text c='text.0' fw='bold' pr='11px'>
                    {children}
                </Text>

                <Box w={66} c='text.0' fw='bold'>
                    {afterLabel}
                </Box>
            </Flex>
        </Flex>
    )
}

export default QuizParameterTemplateDeficit
